import * as React from "react"
import { LinkButton } from "./library/button"
import { trackMembershipFromLocationDetail } from "./library/tracking"

export const contactDetails = (customerSupportText: string): JSX.Element => (
  <div>
    {customerSupportText != "" ? <div dangerouslySetInnerHTML={{__html: customerSupportText}} /> : <></>}
  </div>
)

export const membership = (): JSX.Element => (
  <div>
    <p>
      Met het lidmaatschap van de bieb gaat er een wereld voor je open aan kennis,
      inspiratie en leesplezier. Je hebt altijd iets te lezen, leren of luisteren.
      Online en offline. Ontdek de 160 cursussen, van Spaans leren tot je nachtrust
      verbeteren. Of kies uit ruim 34.000 e-books. Nog geen 18? Dan is jouw
      lidmaatschap gratis.
    </p>

    <LinkButton variant="black" arrow route="/lid-worden" handle={() => trackMembershipFromLocationDetail()}>Ontdek welk abonnement bij jou past</LinkButton>
  </div>
)
